<template>
    <div class="land-flats">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.flats_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.flats_section_title}}</h2> -->
            <h2 v-html="salesCard.flats_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-flats-column-container">
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2>{{salesCard.flats_section_title}}</h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.flats_desc"></div>
                    <div class="flats-desc-list">
                        <ul>
                            <li class="main" v-for="(item, index) in salesCard.flats_pins.slice(0,2)" :key="item.name">
                                <strong v-html="item.name"></strong>
                                <p v-html="item.desc"></p>
                            </li>
                            <li v-for="item in salesCard.flats_pins.slice(4,7)" :key="item.name" v-if="item.name != '' && item.desc != ''">
                                <strong v-html="item.name"></strong>
                                <p v-html="item.desc"></p>
                            </li>
                        </ul>
                        <ul>
                            <li class="main" v-for="(item, index) in salesCard.flats_pins.slice(2,4)" :key="item.name">
                                <strong v-html="item.name"></strong>
                                <p v-html="item.desc"></p>
                            </li>
                            <li v-for="item in salesCard.flats_pins.slice(7)" :key="item.name" v-if="item.name != '' && item.desc != ''">
                                <strong v-html="item.name"></strong>
                                <p v-html="item.desc"></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img">
                        <img :src="salesCard.flats_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-flats',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-flats.scss';
    @import '@/styles/components/sales/respond/land-flats-respond.scss';
</style>